//
// Used as the "customInput" property of the DatePicker, so we can support
// an input mask for manual input.  Implement the focus() method so we don't
// get errors in DatePicker!!
//
import React from "react";
import ReactDOM from "react-dom";
import InputMask from "react-input-mask";

class DateInputField extends React.Component {
  focus() {
    ReactDOM.findDOMNode(this._element).focus();
  }
  render() {
    return (
      <InputMask
        ref={(element) => (this._element = element)}
        mask="mM/dD/9999"
        formatChars={{
          m: "[0-1]",
          M: "[0-9]",
          d: "[0-3]",
          D: "[0-9]",
          "9": "[0-9]",
        }}
        {...this.props}
      />
    );
  }
}

export default DateInputField;
